module.exports = __webpack_public_path__ + "media/media/logos/logo-228063b0bd948074ff1803cfed62e209.png";